var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCabriExpressPrimaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calque",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 850.39 850.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9cffff;\n      }\n\n      .cls-2 {\n        fill: #ffdb00;\n      }\n\n      .cls-3 {\n        fill: url(#D\xE9grad\xE9_sans_nom-3);\n      }\n\n      .cls-4 {\n        fill: url(#D\xE9grad\xE9_sans_nom);\n      }\n\n      .cls-5 {\n        fill: #08f;\n      }\n\n      .cls-6 {\n        fill: url(#D\xE9grad\xE9_sans_nom-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom",
    "data-name": "D\\xE9grad\\xE9 sans nom",
    x1: -89.26,
    y1: 3681.67,
    x2: 38.29,
    y2: 3681.67,
    gradientTransform: "translate(257.63 5161.51) scale(1.32 -1.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cffff",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9cffff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom-2",
    "data-name": "D\\xE9grad\\xE9 sans nom",
    x1: -89.26,
    y1: 3719.88,
    x2: 38.29,
    y2: 3719.88,
    gradientTransform: "translate(257.63 5460.5) scale(1.32 -1.32)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom-3",
    "data-name": "D\\xE9grad\\xE9 sans nom",
    x1: -80.52,
    y1: 3700.78,
    x2: 47.03,
    y2: 3700.78,
    gradientTransform: "translate(189.18 5311.01) scale(1.32 -1.32)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "express-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -1,
    y: 0,
    width: 850.39,
    height: 850.39
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.06,426.92c0,23.53,3.87,44.34,11.61,62.41,7.74,18.08,17.96,33.25,30.68,45.53,12.9,12.28,27.64,21.57,44.22,27.88,16.77,6.31,34.08,9.46,51.95,9.46,13.82,0,26.62-2.22,38.41-6.65,11.98-4.43,23.12-10.32,33.44-17.65,10.5-7.5,20.27-16.12,29.29-25.84,9.03-9.89,17.69-20.29,25.98-31.21l40.35,27.37c-8.66,12.96-19.16,25.41-31.5,37.35-12.16,11.94-25.89,22.51-41.18,31.72-15.29,9.21-31.97,16.54-50.02,22-18.06,5.46-37.12,8.19-57.21,8.19-33.9,0-65.13-4.52-93.68-13.56-28.37-9.21-52.97-22.17-73.79-38.88-20.63-16.71-36.76-36.75-48.36-60.11-11.61-23.36-17.41-49.37-17.41-78.02,0-18.42,2.49-35.9,7.46-52.44,4.97-16.71,12.07-32.14,21.28-46.3,9.4-14.15,20.82-26.86,34.27-38.11,13.45-11.43,28.56-21.15,45.32-29.16,16.95-8.01,35.47-14.15,55.55-18.42,20.08-4.26,41.36-6.39,63.84-6.39,22.66,0,43.39,2.47,62.18,7.42,18.98,4.78,36.11,11.6,51.4,20.46,15.48,8.7,29.2,19.1,41.18,31.21,12.16,12.11,22.84,25.32,32.06,39.65l-40.9,26.35c-8.29-10.91-17.32-21.15-27.08-30.7-9.58-9.72-19.9-18.16-30.95-25.32-11.05-7.33-22.66-13.13-34.82-17.39-12.16-4.26-24.87-6.39-38.14-6.39-18.06,0-35.28,3.16-51.68,9.46-16.4,6.31-30.86,15.6-43.39,27.88-12.34,12.28-22.2,27.46-29.57,45.53-7.19,18.08-10.78,38.97-10.78,62.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 139.82,
    y: 292.99,
    width: 168.33,
    height: 19.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 139.82,
    y: 541.56,
    width: 168.33,
    height: 19.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.92,
    y: 417.27,
    width: 168.33,
    height: 19.05
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M498.07,517.23h-.52c-8.13,0-14.26-6.13-14.26-14.26v-141.26c0-8.13,6.13-14.26,14.26-14.26h24.52c35.94,0,63.04,23.63,63.04,54.96s-27.1,55.09-63.04,55.09h-9.74v45.48c0,8.13-6.13,14.26-14.26,14.26ZM512.33,428.71h9.74c19.7,0,34-11.06,34-26.3s-14.3-26.17-34-26.17h-9.74v52.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCabriExpressPrimaire);
export default __webpack_public_path__ + "static/media/Logo_Cabri_Express_primaire.5099f255b64c0de796ead8e42b8393a0.svg";
export { ForwardRef as ReactComponent };